import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "paymentreceipt",
  listKey: "receipts",
  itemKey: "receipt",
  getAll: types.GET_ALL_PAYMENT_RECEIPTS,
  getAllResponse: types.GET_ALL_PAYMENT_RECEIPTS_RESPONSE,
  getByIdResponse: types.GET_PAYMENT_RECEIPT_BY_ID_RESPONSE,
});
